<template>
  <div id="app">
    <Login v-if="!token" v-on:successfulLogin="saveToken"></Login>
    <UserList v-if="token" :token="token"></UserList>
  </div>
</template>

<script>
import Login from './components/Login'
import UserList from './components/UserList'

export default {
  name: 'app',
  components: {
    UserList,
    Login
  },
  mounted () {
    if (localStorage.token) {
      this.token = localStorage.token
    }
  },
  methods: {
    saveToken (token) {
      localStorage.token = token
      this.token = token
      this.$http.defaults.headers.common['Authorization'] = 'Token ' + token;
    }
  },
  data () {
    return {
      token: null,
      me () {
        this.$http.get('me')
        .then(response => {
          window.console.log(response)
        })
        .catch(error => {
          window.console.log(error)
          localStorage.removeItem('token')
        })
      }
    }
  },
}
</script>

<style>
</style>
